import { AclAssetModuleResourceType } from '@y42/acl/models';
import { Y42FeatureType } from '@y42/json-schema';
import { alertIcon, dataContractIcon, modelIcon } from '../icons';
import { Y42FeatureTypeToLogo } from '../models/feature-type-to-logo.model';

export const AclAssetModuleResourceTypeToLogo: Record<AclAssetModuleResourceType, string> = {
  [AclAssetModuleResourceType.Integrations]: Y42FeatureTypeToLogo[Y42FeatureType.Integration],
  [AclAssetModuleResourceType.Models]: modelIcon,
  [AclAssetModuleResourceType.Visualizations]: Y42FeatureTypeToLogo[Y42FeatureType.VisualizationDashboard],
  [AclAssetModuleResourceType.Orchestrations]: Y42FeatureTypeToLogo[Y42FeatureType.Orchestration],
  [AclAssetModuleResourceType.DataContracts]: dataContractIcon,
  [AclAssetModuleResourceType.DataExports]: Y42FeatureTypeToLogo[Y42FeatureType.Export],
  [AclAssetModuleResourceType.Alerts]: alertIcon,
  [AclAssetModuleResourceType.Lineage]: Y42FeatureTypeToLogo[Y42FeatureType.Lineage],
};
